<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-music-list`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M37.045 20.863a1 1 0 01.556.169l7.527 5.033-2.213 3.328-2.882-1.927V36L40 35.954V36a6 6 0 11-3.954-5.642v-8.495a1 1 0 011-1zM20.953 36a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1v-2a1 1 0 011-1h13.953zM34 34a2 2 0 100 4 2 2 0 000-4zm-5.07-12a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1v-2a1 1 0 011-1h21.93zM39 8a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1V9a1 1 0 011-1h32z"/></svg>
</template>
<script>

export default {
  name: 'IconMusicList',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
